import { Navigate } from 'react-router-dom';
import { clearCustomerSession, isJwtExpired } from '../utils/runtimeConfig';

const CustomerProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('ktc_customer_token');
  
  if (!token) {
    return <Navigate to="/portal/login" replace />;
  }

  if (isJwtExpired(token)) {
    clearCustomerSession();
    return <Navigate to="/portal/login" replace />;
  }
  
  return children;
};

export default CustomerProtectedRoute;
